// Safe configuration utility to handle environment variables in both development and production
const getBackendUrl = () => {
  // For admin preview, use the external URL
  // This is set at build time by webpack
  const envBackendUrl = process.env.REACT_APP_BACKEND_URL;
  
  // Get the current page's origin
  const currentOrigin = typeof window !== 'undefined' ? window.location.origin : '';
  
  // In production deployments (manandmachine.app), ALWAYS use window.location.origin
  // This ensures we never use stale build-time URLs from preview environments
  if (currentOrigin && currentOrigin.includes('manandmachine.app')) {
    console.log('[Config] Production detected, using window.location.origin:', currentOrigin);
    return currentOrigin;
  }
  
  // For non-production, check if envBackendUrl is valid and not a stale preview URL
  // Stale URLs could be from: *.preview.emergentagent.com, *.emergent.host, or other preview domains
  const isStalePreviewUrl = envBackendUrl && (
    envBackendUrl.includes('preview.emergentagent.com') ||
    envBackendUrl.includes('.emergent.host') ||
    envBackendUrl.includes('emergent.host')
  );
  
  // If the env URL doesn't match current origin and looks like a preview URL, fall back
  if (isStalePreviewUrl && currentOrigin && !envBackendUrl.includes(new URL(currentOrigin).hostname)) {
    console.log('[Config] Stale preview URL detected, using window.location.origin:', currentOrigin);
    return currentOrigin;
  }
  
  // Use env URL if it's valid and current
  if (envBackendUrl) {
    console.log('[Config] Using REACT_APP_BACKEND_URL:', envBackendUrl);
    return envBackendUrl;
  }
  
  // Final fallback to window.location.origin
  console.log('[Config] Using window.location.origin:', currentOrigin);
  return currentOrigin;
};

export const BACKEND_URL = getBackendUrl();
console.log('[Config] Final BACKEND_URL:', BACKEND_URL);
